import DataTile from "./DataTile";
import React from "react";
import BBIconConstructionCone from "../../../assets/bbCustomIcons/BBIconConstructionCone";

const Tile = (props) => {

    const {
        subtitle = "Loading...",
        icon = <BBIconConstructionCone style={{fontSize: "70px"}}/>,
        tipText = `Loading...`,
        colorString = "inactive-gray"
    } = props;

    const colorFunction = (stateData) => {
        return colorString;
    }

    // const riskRibbon = (stateData) => {
    //     return <RiskRibbon ratingBy5={0} />
    // }

    const valueFunction = (stateData) => {
        // return <code>0x41</code>
        return <>&nbsp;</>
    }


    return (
        <DataTile
            color = {colorFunction()}
            colorBgFunction={colorFunction}
            subTitle= {subtitle}
            tipText={tipText}
            icon={icon}
            // stateName=""
            // stateElement=""
            // useDeepDataStore
            dontFetch
            forceLoadingState = {true}
            // deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse] : null : null}
            // stateLoaderName=""
            // stateLoaderError=""
            // stateFetchAction={() => null}
            // preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            ribbonFunction={null}
        />
    )

}

export default Tile;